import { Pipe, PipeTransform, inject } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Pipe({ name: "raskSafe" })
export class SafePipe implements PipeTransform {
    protected sanitizer = inject(DomSanitizer);

    transform(value: any): SafeResourceUrl {
        // eslint-disable-next-line sonarjs/no-angular-bypass-sanitization
        return this.sanitizer.bypassSecurityTrustResourceUrl(value);
    }
}
